module.exports = __webpack_public_path__ + "static/media/play_arrow-24px.1501131e.svg";